/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelperNew.js').customRequest;
  var mergeQueryParams = require('./requestHelperNew.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Wyszukiwarka adresów
   * @method
   * @name Api#getWyszukiwarkaAdres
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.adres - Adres
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaAdres = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/adres',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['adres'] !== undefined) {
      queryParameters['adres'] = parameters['adres'];
    }

    if (parameters['adres'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: adres'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  /**
   * Wyszukiwarka Terytów, Województw, Powiatów, Gmin
   * @method
   * @name Api#getWyszukiwarkaAll
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.teryt - Teryt
   * @param {string} parameters.woj - Województwo
   * @param {string} parameters.pow - Powiat
   * @param {string} parameters.gmi - Gmina
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaAll = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/all',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['teryt'] !== undefined && parameters['teryt'] !== '') {
      queryParameters['teryt'] = parameters['teryt'];
    }

    if (parameters['woj'] !== undefined && parameters['woj'] !== '') {
      queryParameters['woj'] = parameters['woj'];
    }

    if (parameters['pow'] !== undefined && parameters['pow'] !== '') {
      queryParameters['pow'] = parameters['pow'];
    }

    if (parameters['gmi'] !== undefined && parameters['gmi'] !== '') {
      queryParameters['gmi'] = parameters['gmi'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka numeru drogi
   * @method
   * @name Api#getWyszukiwarkaDrogi
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {real} parameters.road_number - Numer drogi
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaDrogi = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/drogi',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['road_number'] !== undefined) {
      queryParameters['road_number'] = parameters['road_number'];
    }

    if (parameters['road_number'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: road_number'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka kilometrażu
   * @method
   * @name Api#getWyszukiwarkaKilometraz
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {real} parameters.road_number - Numer drogi
   * @param {string} parameters.mileage - Kilometraż
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaKilometraz = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/kilometraz',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['road_number'] !== undefined) {
      queryParameters['road_number'] = parameters['road_number'];
    }

    if (parameters['road_number'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: road_number'));
      return deferred.promise;
    }

    if (parameters['mileage'] !== undefined) {
      queryParameters['mileage'] = parameters['mileage'];
    }

    if (parameters['mileage'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: mileage'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka dostępnych Województw, Gmin, Powiatów
   * @method
   * @name Api#getWyszukiwarkaListy
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.woj - Województwo
   * @param {string} parameters.pow - Powiat
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaListy = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/listy',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['woj'] !== undefined) {
      queryParameters['woj'] = parameters['woj'];
    }

    if (parameters['pow'] !== undefined) {
      queryParameters['pow'] = parameters['pow'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka po nazwach Województwa, Powiatu, Gminy
   * @method
   * @name Api#getWyszukiwarkaNazwa
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.woj - Województwo
   * @param {string} parameters.pow - Powiat
   * @param {string} parameters.gmi - Gmina
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaNazwa = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/nazwa',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['woj'] !== undefined) {
      queryParameters['woj'] = parameters['woj'];
    }

    if (parameters['pow'] !== undefined) {
      queryParameters['pow'] = parameters['pow'];
    }

    if (parameters['gmi'] !== undefined) {
      queryParameters['gmi'] = parameters['gmi'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka podmiotów wg numeru NIP
   * @method
   * @name Api#getWyszukiwarkaNip
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.nip - Szukany NIP
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaNip = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/nip',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['nip'] !== undefined) {
      queryParameters['nip'] = parameters['nip'];
    }

    if (parameters['nip'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: nip'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka obiektów za pomocą współrzędnych
   * @method
   * @name Api#getWyszukiwarkaObiektWspolrzedne
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.coords_system - Układ współrzędnych
   * @param {number} parameters.x - Współrzędna x
   * @param {number} parameters.y - Współrzędna y
   * @param {string} parameters.tolerance - Tolerancja
   * @param {string} parameters.active_layer - Warstwa aktywna
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaObiektWspolrzedne = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/obiekt_wspolrzedne',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['coords_system'] !== undefined) {
      queryParameters['coords_system'] = parameters['coords_system'];
    }

    if (parameters['coords_system'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: coords_system'));
      return deferred.promise;
    }

    if (parameters['x'] !== undefined) {
      queryParameters['x'] = parameters['x'];
    }

    if (parameters['x'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: x'));
      return deferred.promise;
    }

    if (parameters['y'] !== undefined) {
      queryParameters['y'] = parameters['y'];
    }

    if (parameters['y'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: y'));
      return deferred.promise;
    }

    if (parameters['tolerance'] !== undefined) {
      queryParameters['tolerance'] = parameters['tolerance'];
    }

    if (parameters['tolerance'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: tolerance'));
      return deferred.promise;
    }

    if (parameters['active_layer'] !== undefined) {
      queryParameters['active_layer'] = parameters['active_layer'];
    }

    if (parameters['active_layer'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: active_layer'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka obrębów ewidencyjnych PRG
   * @method
   * @name Api#getWyszukiwarkaObrebyEwidencyjnePrg
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.gmina - Kod TERYT gminy
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaObrebyEwidencyjnePrg = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/obreby_ewidencyjne_prg',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['gmina'] !== undefined) {
      queryParameters['gmina'] = parameters['gmina'];
    }

    if (parameters['gmina'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: gmina'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka numeru drogi
   * @method
   * @name Api#getWyszukiwarkaSimc
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.woj - Nr województwa
   * @param {string} parameters.gmi - Nr gminy
   * @param {string} parameters.pow - Nr powiatu
   * @param {string} parameters.nazwa_search - nazwa
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaSimc = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/simc',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['woj'] !== undefined) {
      queryParameters['woj'] = parameters['woj'];
    }

    if (parameters['gmi'] !== undefined) {
      queryParameters['gmi'] = parameters['gmi'];
    }

    if (parameters['pow'] !== undefined) {
      queryParameters['pow'] = parameters['pow'];
    }

    if (parameters['nazwa_search'] !== undefined) {
      queryParameters['nazwa_search'] = parameters['nazwa_search'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka po kodzie TERYT
   * @method
   * @name Api#getWyszukiwarkaTeryt
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.teryt - Teryt
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaTeryt = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/teryt',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['teryt'] !== undefined) {
      queryParameters['teryt'] = parameters['teryt'];
    }

    if (parameters['teryt'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: teryt'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Wyszukiwarka numeru drogi
   * @method
   * @name Api#getWyszukiwarkaUlic
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.kod_simc - Kod SIMC miejscowości
   * @param {string} parameters.nazwa_search - Fragment nazwy ulicy
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getWyszukiwarkaUlic = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/wyszukiwarka/ulic',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['kod_simc'] !== undefined) {
      queryParameters['kod_simc'] = parameters['kod_simc'];
    }

    if (parameters['nazwa_search'] !== undefined) {
      queryParameters['nazwa_search'] = parameters['nazwa_search'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getProvinces = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.geocodingApiUrl,
      path = '/GetProvinces',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getDistricts = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.geocodingApiUrl,
      path = '/GetDistricts',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wojewodztwoid'] !== undefined) {
      queryParameters['wojewodztwoid'] = parameters['wojewodztwoid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getCommunes = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.geocodingApiUrl,
      path = '/GetCommunes',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['powiatid'] !== undefined) {
      queryParameters['powiatid'] = parameters['powiatid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getCities = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.geocodingApiUrl,
      path = '/GetCities',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['gminaid'] !== undefined) {
      queryParameters['gminaid'] = parameters['gminaid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getStreets = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.geocodingApiUrl,
      path = '/GetStreets',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['simc'] !== undefined) {
      queryParameters['simc'] = parameters['simc'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getAddressesForTeryt = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.geocodingApiUrl,
      path = '/GetAddressesForTeryt',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['teryt'] !== undefined) {
      queryParameters['teryt'] = parameters['teryt'];
    }

    if (parameters['limit'] !== undefined) {
      queryParameters['limit'] = parameters['limit'];
    }
    // default limit is 500

    if (parameters['skip'] !== undefined) {
      queryParameters['skip'] = parameters['skip'];
    }
    // let you skip first n positions

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getAddressesForStreet = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.geocodingApiUrl,
      path = '/GetAddressesForStreet',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['simc'] !== undefined) {
      queryParameters['simc'] = parameters['simc'];
    }

    if (parameters['ulic'] !== undefined) {
      queryParameters['ulic'] = parameters['ulic'];
    }

    if (parameters['limit'] !== undefined) {
      queryParameters['limit'] = parameters['limit'];
    }
    // default limit is 500

    if (parameters['skip'] !== undefined) {
      queryParameters['skip'] = parameters['skip'];
    }
    // let you skip first n positions

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getUslugiPktAdresowe = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl,
      path = '/api/getAddressPointServices',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['application/json'];

    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false,
      jsonData: true
    };

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getLayerInPolygon = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl,
      path = '/api/getLayerInPolygon',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['application/json'];

    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false,
      jsonData: true
    };

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getFeaturesInRadius = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl,
      path = '/api/getLayerInRadius',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }
    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['application/json'];

    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false,
      jsonData: true
    };

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.getFeaturesInPolygonFromAnyLayer = function(
    parameters,
    options
  ) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = settingsInstance.geoserverUrl,
      path = '/pit/ows',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['application/json'];

    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false,
      jsonData: true
    };

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }
    queryParameters['service'] = 'WFS';
    queryParameters['version'] = '1.0.0';
    queryParameters['request'] = 'GetFeature';
    queryParameters['srsName'] = 'EPSG:2180';
    if (parameters['typeNames'] !== undefined) {
      queryParameters['typeNames'] = parameters['typeNames'];
    }
    queryParameters['outputFormat'] = 'application/json';

    if (parameters['count'] !== undefined) {
      queryParameters['count'] = parameters['count'];
    }
    if (parameters['maxfeatures'] !== undefined) {
      queryParameters['maxfeatures'] = parameters['maxfeatures'];
    }
    if (parameters['cql_filter'] !== undefined) {
      queryParameters['cql_filter'] = parameters['cql_filter'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.postExportCsvSearchResults = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl, //do sparametryzowania
      path = '/api/exportCsv',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};
    headers['Accept'] = ['text/csv'];

    headers['Content-Type'] = ['application/json'];
    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.postExportXlsxSearchResults = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl, //do sparametryzowania
      path = '/api/exportXlsx',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['text/csv'];

    headers['Content-Type'] = ['application/json'];
    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }
    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.postExportPdfSearchResults = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl, //do sparametryzowania
      path = '/api/exportPdf',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['text/csv'];

    headers['Content-Type'] = ['application/json'];
    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  Api.prototype.postExportPdfMap = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl, //do sparametryzowania
      path = '/api/convertImageToPdf',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['text/csv'];

    headers['Content-Type'] = ['application/json'];
    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
